import {Device} from 'epic-fortnite-styles/constants';
import styled, {css} from 'styled-components';

import Content from './Content';
import MobileSubTitle from './MobileSubTitle';
import StyledBadge from './StyledBadge';
import StyledBtnWrapper from './StyledBtnWrapper';
import StyledPlayVideo from './StyledPlayVideo';
import SubTitle from './SubTitle';

// Options available in the CMS.
// We can expand on these as needed.
// Current usage is only applying the layout within the lara croft carousel type.
const layoutTheme = {
  // left: null,
  // center: null,
  // right: null,
  // leftv2: null,
  // topCenter: null,
  // desktopleftmobiletop: null,
  desktoprightmobiletop: css`
    ${Content} {
      position: absolute;
      right: 5%;

      @media screen and ${Device.mobileL} {
        height: auto;
        top: 5%;
        width: 90%;
      }

      ${StyledBadge} {
        width: 100%;
      }
    }

    ${StyledBtnWrapper} {
      position: absolute;
      right: 0;
      width: 40%;
      bottom: 15%;

      @media screen and ${Device.laptop} {
        bottom: 40%;
        right: 10%;
        width: unset;
        margin: 0;
      }

      @media screen and ${Device.mobileL} {
        bottom: 15%;
        left: 42%;
        transform: translateX(-50%);
      }
    }
  `,
};

const StyledVideoHeaderC2s6 = styled.div<{captionPos: string}>`
  height: 90vh;
  background-color: white;
  min-height: 900px;
  @media screen and (max-width: 1700px) {
    min-height: 850px;
  }
  position: relative;
  overflow: hidden;
  @media screen and ${Device.laptopL} {
    height: 68vh;
    min-height: 600px;
  }
  @media screen and ${Device.laptop} {
    height: 54vh;
    min-height: 450px;
  }
  @media screen and ${Device.mobileL} {
    height: 100vh;
    min-height: 1350px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding-top: 0;
    padding-bottom: 0;
  }
  @media screen and ${Device.mobileL} {
    min-height: 700px;
    height: 100vh;
  }
  @media screen and ${Device.mobileM} {
    min-height: 650px;
    height: 90vh;
  }
  @media screen and ${Device.mobileS} {
    height: 80vh;
    min-height: 600px;
  }
  .header {
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    @media screen and ${Device.mobileL} {
      height: calc(177vw - 3.7em);
    }
  }
  ${StyledPlayVideo} {
    bottom: 13%;
    right: 3%;
    @media screen and ${Device.desktopS} {
      bottom: 10%;
    }
    @media screen and ${Device.laptopL} {
      bottom: 10%;
    }
    @media screen and ${Device.tablet} {
      bottom: 5%;
    }
    @media screen and ${Device.mobileL} {
      right: unset;
      bottom: 5em;
    }
  }
  &.overview ${StyledPlayVideo} {
    bottom: 13%;
    right: 3%;
    @media screen and ${Device.desktopS} {
      bottom: 10%;
    }
    @media screen and ${Device.laptopL} {
      bottom: 10%;
    }
    @media screen and ${Device.tablet} {
      bottom: 5%;
    }
    @media screen and ${Device.mobileL} {
      right: unset;
      bottom: 5em;
    }
  }
  ${({theme}) => `
        ${
          (theme.locale === 'ar' &&
            `
            ${StyledPlayVideo} {
                left: 3%;
                right: unset;
                @media screen and ${Device.mobileL} {
                    left: unset;
                }
            }
        `) ||
          ''
        }
    `}

  &.lara-croft-slide ${Content} {
    width: 30%;
    margin-left: 9.5%;
    margin-top: 16%;

    @media screen and ${Device.mobileL} {
      width: 100%;
      margin-left: 0;
      margin-top: 0;
      height: 80%;
    }
    h2 {
      color: black;
      font-size: 3em;
      letter-spacing: 0.3em;
      margin: 0;
      @media screen and ${Device.mobileL} {
        font-size: 1.7em;
      }
    }
    ${SubTitle}, ${MobileSubTitle} {
      color: white;
      letter-spacing: 0.3em;
    }
  }

  &.lara-croft-slide {
    ${StyledBtnWrapper} {
      position: unset;
      bottom: unset;
      width: 30%;
      margin-left: 9.5%;
      @media screen and ${Device.mobileL} {
        width: 100%;
        margin-left: 0;
        margin-top: 0;
        margin-bottom: 20%;
      }
    }
    &&& .btn.btn-display:after {
      background-color: black;
    }
    &&& .btn.btn-display {
      margin-top: 0em;
      span {
        color: white;
      }
    }

    ${({captionPos}) => (captionPos && layoutTheme[captionPos] ? layoutTheme[captionPos] : null)}
  }
`;

export default StyledVideoHeaderC2s6;
